const workflow = {
  workflow: {
    options: {
      min: {
        icon: 'turtle',
        value: '1400'
      },
      eco: {
        icon: 'leaf',
        value: '1800'
      },
      max: {
        icon: 'rabbit',
        value: '2600'
      }
    },
    engineNotStartedValues: [
      {
        icon: 'icon-xm-battery',
        value: '14.5'
      },
      {
        icon: 'icon-xm-flask-wrench',
        value: '313.2'
      },
      {
        icon: 'icon-xm-drop-wrench',
        value: '713.2'
      },
      {
        icon: 'icon-xm-flask-hourglass',
        value: '286.8'
      }
    ]
  }
};

export default workflow;



// WEBPACK FOOTER //
// ./src/screens/data/flow4/workflow.js